import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/styles';
import { LoanStatus } from '@nemuru-eng/js-api-client';
import { Fragment } from 'react';

import { Text } from '@/components/shared/components/Text';
import { CustomPalette } from '@/config/types';
import { adjustColorToPalette } from '@/utils/getColorPalette';
import { getLoanStatusListDefinitions } from '@/utils/getLoanStatusListDefinitions';

interface LoanStatusTagProps {
  status: LoanStatus;
  hideStatusName?: boolean;
}
export function LoanStatusTag({ status, hideStatusName = false }: LoanStatusTagProps) {
  const richStatus = getLoanStatusListDefinitions()[status];
  const { palette }: { palette: CustomPalette } = useTheme();
  const color = adjustColorToPalette(richStatus.colorPaletteName, richStatus.colorType, palette);

  return (
    <Fragment>
      {richStatus ? (
        <Fragment>
          <Box bgcolor={color} className={'circle mr-2'} style={{ marginBottom: '-1px' }} />
          {!hideStatusName && (
            <span>
              <Text tId={richStatus.SECTION_T_ID} />
            </span>
          )}
        </Fragment>
      ) : (
        status
      )}
    </Fragment>
  );
}
